import React, { useEffect, useState } from "react";
import { Box, Drawer } from "@mui/material";
import { AddRounded as AddIcon } from "@mui/icons-material";
import { DrawerHeader, DrawerFooter, FormTextField } from "../../../atoms";
import DrawerField from "../../../molecules/DrawerField";
import { tileInputProps } from "../../../molecules/InfoTile";
import { useClinicTheme } from "../../../../theme";
import { COLORS } from "../../../../styles/uiConstants";

/**
 * Listeye serbest metinli tek öğe ekleyen drawer (bildirim şıkkı vb.).
 * Enter ile de eklenir. Listede zaten olan metin eklenemez.
 *
 * @param {boolean} open
 * @param {() => void} onClose
 * @param {React.ReactNode} icon
 * @param {string} title
 * @param {string} [subtitle]
 * @param {string} label - Alan etiketi
 * @param {string} [placeholder]
 * @param {string[]} [existing]
 * @param {(text: string) => void} onSubmit
 */
export default function TextItemDrawer({
  open,
  onClose,
  icon,
  title,
  subtitle,
  label,
  placeholder,
  existing = [],
  onSubmit,
}) {
  const { palette } = useClinicTheme();
  const [text, setText] = useState("");

  useEffect(() => {
    if (open) setText("");
  }, [open]);

  const value = text.trim();
  const duplicate = Boolean(value) && existing.some((e) => e.toLocaleLowerCase("tr") === value.toLocaleLowerCase("tr"));
  const canSubmit = Boolean(value) && !duplicate;
  const submit = () => canSubmit && onSubmit(value);

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          width: { xs: "100%", sm: 440 },
          bgcolor: COLORS.white,
          boxShadow: "0 8px 32px 0 rgba(60,72,100,0.15)",
          display: "flex",
          flexDirection: "column",
        },
      }}
    >
      <DrawerHeader icon={icon} title={title} subtitle={subtitle} onClose={onClose} />
      <Box sx={{ flex: 1, minHeight: 0, overflowY: "auto", px: 3, py: 2.5 }}>
        <DrawerField label={`${label} *`} hint={duplicate ? "Bu öğe listede zaten var." : undefined}>
          <FormTextField
            palette={palette}
            variant="standard"
            size="small"
            fullWidth
            autoFocus
            placeholder={placeholder}
            value={text}
            onChange={(e) => setText(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
                submit();
              }
            }}
            inputProps={{ "aria-label": label }}
            InputProps={tileInputProps(true)}
          />
        </DrawerField>
      </Box>
      <DrawerFooter
        onCancel={onClose}
        cancelLabel="Vazgeç"
        onSubmit={submit}
        submitLabel="Ekle"
        disabled={!canSubmit}
        startIcon={<AddIcon />}
        fullWidth
      />
    </Drawer>
  );
}
